import { Box } from "styles/globalComponents";
import { Loading } from "Utils/Loading";
import { Pagination } from "Components/Pagination";
import { useProducts } from "Hooks/useProducts";
import { useParams } from "react-router";
import { useQuery } from "react-query";
import { listProductsOnBudgetsCart } from "Requests/Partners/Budgets";
import { BUDGETSTATUS } from "Constants/Budget";
import { ProductsListResult } from "./ProductResultList";
import { Filters } from "./Filters";

export const ChooseProducts = () => {
  const {
    fetchNewPage,
    loadingProducts,
    pageSelected,
    productsList,
    productsPagination,
    handleClearData,
    setProductFilters,
  } = useProducts({
    initialFilters: {
      categories: "1,2,3",
      services: "4",
    },
    enableReq: true,
  });

  const { id } = useParams<{ id: string }>();

  const { data, isLoading } = useQuery({
    queryFn: () => listProductsOnBudgetsCart(Number(id)),
    queryKey: ["budget-cart-items-units", id],
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  return (
    <div>
      <h5 className="title-search-products-budget">
        Buscar produtos Testes,Exames ou Check-ups
      </h5>

      <Filters
        getProducts={setProductFilters}
        fetchNewPage={fetchNewPage}
        clearFetchedData={handleClearData}
        blockedInteractions={data?.status?.id === BUDGETSTATUS.converted}
      />

      {loadingProducts ? (
        <Box mt="30">
          <Loading />
        </Box>
      ) : (
        <div className={`cart-flex-products ${false ? "blocked" : ""} `}>
          {!productsList && !loadingProducts && (
            <p className="text-danger text-display text-center text-no-margin">
              Oops! Nenhum produto encontrado...
            </p>
          )}

          {productsList && productsList?.length >= 1 && (
            <>
              <ProductsListResult productsList={productsList} />

              {productsPagination?.total_pages &&
                productsPagination.total_pages > 1 && (
                  <Box mt="20" pb="20">
                    <Pagination
                      pageLimit={1}
                      pageNeighbours={2}
                      totalRecords={productsPagination?.total_pages}
                      currentPageSelected={pageSelected}
                      onPageChanged={(pageObject) => {
                        if (data?.status?.id === BUDGETSTATUS.converted) return;
                        fetchNewPage(pageObject.currentPage);
                      }}
                    />
                  </Box>
                )}
            </>
          )}
        </div>
      )}
    </div>
  );
};
